/* Source: /home/sidsolaiyappan/skooch_ai/shared/dev_flags.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function isDevXrayFrom(windowFlag, lsValue) {
  if (windowFlag) {
    return true;
  }
  if ((lsValue === "1")) {
    return true;
  }
  return false;
}
function isDevXray() {
  let _wf = null;
  let _ls = null;
  try {
    _wf = window.__skoochXray;
  } catch (__jac_e) {
    if (true) {
      let _wfErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    _ls = localStorage.getItem("skooch_dev_xray");
  } catch (__jac_e) {
    if (true) {
      let _lsErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  return isDevXrayFrom(_wf, _ls);
}
function resolveChatBrain(windowFlag, lsValue) {
  if (((windowFlag !== undefined) && (windowFlag !== null))) {
    return (windowFlag ? "fc" : "old");
  }
  if ((lsValue === "1")) {
    return "fc";
  }
  if ((lsValue === "0")) {
    return "old";
  }
  return "fc";
}
function chatBrainMode() {
  let _wf = null;
  let _ls = null;
  try {
    _wf = window.__skoochFcBrain;
  } catch (__jac_e) {
    if (true) {
      let _wfe = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    _ls = localStorage.getItem("skooch_fc_brain");
  } catch (__jac_e) {
    if (true) {
      let _lse = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  return resolveChatBrain(_wf, _ls);
}
function resolveChatLoop(windowFlag, lsValue) {
  if (((windowFlag !== undefined) && (windowFlag !== null))) {
    return (windowFlag ? true : false);
  }
  if ((lsValue === "1")) {
    return true;
  }
  if ((lsValue === "0")) {
    return false;
  }
  return false;
}
function chatLoopMode() {
  let _wf = null;
  let _ls = null;
  try {
    _wf = window.__skoochFcLoop;
  } catch (__jac_e) {
    if (true) {
      let _wfe = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    _ls = localStorage.getItem("skooch_fc_loop");
  } catch (__jac_e) {
    if (true) {
      let _lse = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  return resolveChatLoop(_wf, _ls);
}
export {chatBrainMode, chatLoopMode, isDevXray, isDevXrayFrom, resolveChatBrain, resolveChatLoop};
//# sourceMappingURL=dev_flags.js.map
